export default __webpack_public_path__ + "static/media/news_bg.b8ee7570.png";